import { GET_ADD_FUNDS_LIMITS_URL } from '@/modules/addFunds/endpoints'
import ApiErrorFactory from '@/entities/errors/api_errors/ApiErrorsFactory'
import { AddFundsPayloadI, PayInvoicePayloadI } from '@/modules/addFunds/types/api/Funds'
import AxiosFactory from '@/entities/security/AxiosFactory'
import { GET_INVOICE_URL } from '../invoice/endpoints'
import { PAYMENT_RULES_URL } from '../paymentMethods/endpoints'

export default class FundsApi {
  async loadAddFundsLimits() {
    try {
      const response = await AxiosFactory.createAxiosInstance().get(GET_ADD_FUNDS_LIMITS_URL)
      return response
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }
  // The deposit is created and charged in one call: the backend raises the invoice and settles it
  // against the payment intent we hand over, so the client never pays a separate invoice.
  async addFunds(data: AddFundsPayloadI) {
    try {
      const response = await AxiosFactory.createAxiosInstance().post(GET_ADD_FUNDS_LIMITS_URL, data)
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }
  async loadInvoice(id: number) {
    try {
      const response = await AxiosFactory.createAxiosInstance().get(GET_INVOICE_URL + `/${id}`)
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }
  async payInvoice(payload: PayInvoicePayloadI) {
    try {
      const { invoiceId, ...data } = payload
      const response = await AxiosFactory.createAxiosInstance().post(GET_INVOICE_URL + `/${invoiceId}` + '/pay', data)
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }
  async getPaymentInvoiceRules(id: number) {
    try {
      const response = await AxiosFactory.createAxiosInstance().get(PAYMENT_RULES_URL + `?invoiceId=${id}`)
      return response.data.allowedGateways
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }
}
